import React from 'react';
import { PersonInformation } from '../../../../components/molecules/PersonInformation';
import { LiProps } from '../../../../types/HtmlProps';
import { ContactPerson } from '../../ContactPerson';

type PersonInformationListItemProps = {
  person: ContactPerson;
} & LiProps;

export function PersonInformationListItem({ person, ...liProps }: PersonInformationListItemProps) {
  return (
    <li {...liProps}>
      <PersonInformation
        profileImageUrl={person.profileImageUrl}
        infoCardUrl={person.personInfoCardUrl}
        profileName={person.profileName}
        profileLink={person.profileLink}
        roleNames={person.roleNames}
      />
    </li>
  );
}
